import * as yup from 'yup'

export const addBancaSchema = yup.object({
	name: yup.string().required(),
})
